import { render, staticRenderFns } from "./service_online.vue?vue&type=template&id=2f3d88bb&scoped=true"
import script from "./service_online.vue?vue&type=script&lang=js"
export * from "./service_online.vue?vue&type=script&lang=js"
import style0 from "./service_online.vue?vue&type=style&index=0&id=2f3d88bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d88bb",
  null
  
)

export default component.exports